import { lazy } from 'react';

import { PATHS } from '@/constants/page-paths';


export const publicRoutes = [
  {
    path: PATHS.SIGN_IN,
    name: 'Sign In',
    component: lazy(() => import('@/pages/auth/Login/SignIn')),
  },
  {
    path: PATHS.REGISTER,
    name: 'Register',
    component: lazy(() => import('@/pages/auth/SignUp/Register')),
  },
  {
    path: PATHS.FORGOT_PASSWORD,
    name: 'Forgot Password',
    component: lazy(() => import('@/pages/auth/forgetPassword/Forgotpassword'))
  },
  {
    path: PATHS.VERIFY_OTP,
    name: 'Verify OTP',
    component: lazy(() => import('@/pages/auth/VerifyOtp'))
  },
  {
    path: PATHS.RESET_PASSWORD,
    name: 'Reset Password',
    component: lazy(() => import('@/pages/auth/resetPassword/ResetPassword'))
  }
 
];

export const publicRouteNames = publicRoutes.map((route) => route.name);

export const publicRoutePaths = publicRoutes.map((route) => route.path);

export default publicRoutes;